// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Layout ────────────────────────────────────────────────────────────────── */
#map {
  margin-top: 0;
  padding: 0 16px 16px;
  background: #f8fafc;
  min-height: calc(100vh - 60px);
}

.map-wrapper {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  height: calc(100vh - 200px);
  display: flex;
  flex-direction: column;
}

/* ── Header ────────────────────────────────────────────────────────────────── */
.map-header {
  padding: 14px 18px;
  border-bottom: 1px solid #eef2f7;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-shrink: 0;
}

.map-heading {
  font-size: 16px;
  font-weight: 600;
  color: #0f172a;
  margin: 0;
}

.map-subheading {
  font-size: 13px;
  color: #64748b;
  margin: 4px 0 0;
}

/* ── Live badge ────────────────────────────────────────────────────────────── */
.live-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: #10b981;
}

.live-badge::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #10b981;
  animation: livePulse 1.5s ease-out infinite;
}

@keyframes livePulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

/* ── Tooltip card ──────────────────────────────────────────────────────────── */
.driver-card {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  white-space: nowrap;
}

/* ── Leaflet overrides ─────────────────────────────────────────────────────── */
.leaflet-container {
  font-family: inherit;
  flex: 1 1; /* fills the remaining wrapper height */
}
`, "",{"version":3,"sources":["webpack://./src/Css/map.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;AACxB;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,iFAAiF;AACjF;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,iFAAiF;AACjF;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,iFAAiF;AACjF;EACE,oBAAoB;EACpB,SAAO,EAAE,uCAAuC;AAClD","sourcesContent":["/* ── Layout ────────────────────────────────────────────────────────────────── */\r\n#map {\r\n  margin-top: 0;\r\n  padding: 0 16px 16px;\r\n  background: #f8fafc;\r\n  min-height: calc(100vh - 60px);\r\n}\r\n\r\n.map-wrapper {\r\n  background: #fff;\r\n  border-radius: 16px;\r\n  overflow: hidden;\r\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);\r\n  height: calc(100vh - 200px);\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n/* ── Header ────────────────────────────────────────────────────────────────── */\r\n.map-header {\r\n  padding: 14px 18px;\r\n  border-bottom: 1px solid #eef2f7;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.map-heading {\r\n  font-size: 16px;\r\n  font-weight: 600;\r\n  color: #0f172a;\r\n  margin: 0;\r\n}\r\n\r\n.map-subheading {\r\n  font-size: 13px;\r\n  color: #64748b;\r\n  margin: 4px 0 0;\r\n}\r\n\r\n/* ── Live badge ────────────────────────────────────────────────────────────── */\r\n.live-badge {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  letter-spacing: 0.06em;\r\n  color: #10b981;\r\n}\r\n\r\n.live-badge::before {\r\n  content: \"\";\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  background: #10b981;\r\n  animation: livePulse 1.5s ease-out infinite;\r\n}\r\n\r\n@keyframes livePulse {\r\n  0% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: scale(2);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n/* ── Tooltip card ──────────────────────────────────────────────────────────── */\r\n.driver-card {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.5;\r\n  white-space: nowrap;\r\n}\r\n\r\n/* ── Leaflet overrides ─────────────────────────────────────────────────────── */\r\n.leaflet-container {\r\n  font-family: inherit;\r\n  flex: 1; /* fills the remaining wrapper height */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
